// extracted by mini-css-extract-plugin
module.exports = {"basketSummaryWrapper":"BasketSummary_basketSummaryWrapper__5ib_G"};